<template>
  <BLayoutDetach
    v-if="isDetachedPage"
    data-app="true"
    :ready="isReadyToStart"
  />

  <BLayoutAuth
    v-else-if="isAuthorizedRoute"
    :ready="isReadyToStart"
  />

  <BLayoutAdmin
    v-else-if="!isLkSystem"
    :ready="isReadyToStart"
  />

  <BLayoutLK
    v-else
    :ready="isReadyToStart"
    data-app="true"
    class="v-application--is-ltr"
  />
</template>

<script>
import { preferenceMapper } from '@/store/modules/preference'
import * as MENU_FOLDERS from '@/helpers/enums/menu-folders'
import { AUTH_ROUTES } from '@/views/Auth/utils'


const BLayoutAuth = () => import(
  /* webpackChunkName: "BLayoutAuth" */
  '@/layouts/BLayoutAuth.vue'
)

const BLayoutAdmin = () => import(
  /* webpackChunkName: "BLayoutAdmin" */
  '@/layouts/BLayoutAdmin.vue'
)

const BLayoutLK = () => import(
  /* webpackChunkName: "BLayoutLK" */
  '@/layouts/BLayoutLK.vue'
)

const BLayoutDetach = () => import(
  /* webpackChunkName: "BLayoutDetach" */
  '@/layouts/BLayoutDetach.vue'
)

export default {
  name: 'BApp',
  components: {
    BLayoutAuth,
    BLayoutAdmin,
    BLayoutLK,
    BLayoutDetach,
  },
  data: () => ({
    isReadyToStart: false,
  }),
  computed: {
    ...preferenceMapper.mapState(['selectedMenuSystem']),

    isDetachedPage() {
      return this.$route.path?.includes('/detach/')
    },
    isLkSystem() {
      return this.selectedMenuSystem?.name === MENU_FOLDERS.SERVICE_LK.name
    },
    isAuthorizedRoute() {
      return this.$route.name?.includes(AUTH_ROUTES.LAYOUT)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.updateSelectedMenuSystem()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...preferenceMapper.mapActions([
      'setMenuSystem',
    ]),

    init() {
      // On start app getProfile exec in access plugin
      // this.getProfile()
      this.$router.onReady(() => {
        this.isReadyToStart = true
        this.$nextTick(this.onChangeLkSystem)
      })
    },
    updateSelectedMenuSystem() {
      const matched = this.$route.matched[0]
      if (!matched) return

      const selected = Object.values(MENU_FOLDERS)
        .find((_) => _.name === matched.name)
      if (!selected) return

      if (selected?.name !== this.selectedMenuSystem.name) {
        this.isActiveMenuSystem = false
        this.onSetMenuSystem(selected)
      }
    },
    onSetMenuSystem(data) {
      if (data?.href) return
      this.setMenuSystem(data)
    },
  },
}
</script>
